export const formatNumberWithLeadingZero = (number) => String(number).padStart(2, '0');
